// Keyset pagination posture (docs/04-api-contract.md §9; docs/09-frontend-
// surface.md §6). List reads send `page_size` (default 50, server cap 200) and
// the opaque `page_token` cursor, and consume `{ items, next_page_token }`.
// Offset pagination is never synthesized: the client never parses, constructs,
// or mutates `page_token` — it passes the server's token back verbatim.

export const DEFAULT_PAGE_SIZE = 50;
export const MAX_PAGE_SIZE = 200;

export interface KeysetPage {
  readonly next_page_token?: string | null;
}

// `getNextPageParam` for TanStack `useInfiniteQuery`: surface the opaque
// cursor verbatim, or `undefined` to stop (empty/absent token = last page).
export function nextPageParam(page?: KeysetPage): string | undefined {
  return page?.next_page_token ?? undefined;
}
